import { graphql } from "@/lib/gql/__generated__";

export const OPTION_PMS_COLOR_ITEM_UPDATE_FOR_OPTION_PMS_MUTATION = graphql(/* GraphQL */ `
	mutation OptionPmsColorItemUpdateForOptionPms($input: OptionPmsColorItemInput!) {
		optionPmsColorItemUpdate(input: $input) {
			colorItem {
				id
				hotelID
				optionID
				optionName
				color
			}
			userErrors
		}
	}
`);
